import cn from "classnames"

import { Flex, Text } from "@/atoms"
import { Trans, useTranslation } from "@/hooks/useTranslation"
import { Heading } from "@/molecules/Heading"
import {
  getEnforcementValues,
  getValues,
  translationsWithVM
} from "@/pages/TriagePage/components/pages/AdrPage/helpers"
import { Steps } from "./Steps"
import { StepsTemplate } from "./StepsTemplate"

import styles from "./OverviewStepsAdr.module.scss"

import type { OverviewStepsAdrProps } from "./OverviewStepsAdr.types"

export const OverviewStepsAdr = (props: OverviewStepsAdrProps) => {
  const { incident } = props
  const keyPrefix = `triage.adr.incidents.${incident.type}.overview.steps`
  const { t } = useTranslation("translation", { keyPrefix })
  const { what, where } = incident
  const values = getValues({
    ...what,
    ...where,
    ...getEnforcementValues(incident)
  })

  return (
    <div className={cn("i-trans-adr", styles.container)}>
      <Flex vertical gap={24}>
        <Flex vertical gap={4} className={styles.wrapper}>
          <Heading capitalize={false} level={4} title={t("title", values)} />
          <Flex vertical>
            <Text>
              <Trans>
                {translationsWithVM("description", incident, { t, values })}
              </Trans>
            </Text>
          </Flex>
        </Flex>
        <StepsTemplate items={Steps(props)} />
      </Flex>
    </div>
  )
}
